import React from 'react';
import { FormControl } from 'react-bootstrap';
import styled from 'styled-components';

// Define types for the props
interface GenericInputProps {
  label: string;  // Label text for the input field
  value: any;  // The value of the input
  onChange: (value: string) => void;  // Change handler
  type?: string;  // The type of the input (e.g., 'text', 'number', 'password', etc.)
  placeholder?: string;  // Placeholder text for the input field
  disabled?:boolean;
  maxLength?:number;
}

// Styled component for the input container
const InputWrapper = styled.div`
  width: 100%;  // Make the wrapper take up full width
  min-width: 200px;  // Set a minimum width for larger screens
  margin-bottom: 1rem;  // Space between inputs

  @media (max-width: 576px) {
    min-width: 100%;  // Full width on mobile devices
  }
`;

// Styled component for the input label
const InputLabel = styled.label`
  font-size: 1rem;
  font-weight: 600;
  color: #000;  // Black text for the label
  margin-bottom: 0.5rem;
  display: block;  // Make sure label appears above the input
`;

// Styled component for the input field (neutral style)
const StyledInput = styled(FormControl)`
  width: 100%;  // Make the input span full width
  padding: 10px 12px;  // Adjust padding for consistency on mobile
  border: 1px solid #ccc;  // Subtle border
  color: #000;  // Set text color to black
  box-shadow: none;  // Remove shadow for a more neutral design

  &:focus {
    border-color: #aaa;  // Slightly darker border on focus
    box-shadow: none;  // Remove default focus shadow
  }

  &:hover {
  --  background-color: #e9ecef;  // Slight change on hover for user interaction feedback
  }
`;

const GenericInput: React.FC<GenericInputProps> = ({ label, value, onChange, type = 'text', placeholder, disabled, maxLength }) => {
  return (
    <InputWrapper>
      {/* Input Label */}
      <InputLabel>{label}</InputLabel>

      {/* Custom Input Field */}
      <StyledInput
        type={type}
        disabled={disabled}
        value={value}
        maxLength={maxLength}
        onChange={(e: any) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </InputWrapper>
  );
}

export default GenericInput;
